module.exports = "iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAAOxJREFUKBWVkTEOgkAQAIHOjsbWggdY2JnYWvoAPmBC5RNoiC/QD1CTWJj4AWtiSWwsbaw00EDiyN0Kp0ETvUBub5nZzR42llU//y+nVWYzyyrLuowq9eWNohZX7eBygcEAej04neisPIfxWMqlqd5FVOT9DvO5fNxsjHs4SG40gttN8mo83dFgkCQCBgGsVhKH4Suhc11RIVkGti3SdvsuqdPHjscjOA54HkynIu/373JHjGMBFwsDrteSWy5NrhWrCnxfgN3OAE30vEkmEygKzcmMrgv9PpzPDdrdr1cYDqV43dHWg5rf+nP0AIBceGzTP/5wAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/WO.png
// module id = 474
// module chunks = 0